import { IReminder } from "./IReminder";
import { IComment } from "./IComment";

export enum ChaseActivityType {
  CLOSE = "Chase::CloseActivity",
  FAIL_AUDIT = "Chase::FailAuditActivity",
  FLAG = "Chase::FlagActivity",
  HOT_CHASE = "Chase::HotActivity",
  MARKED_ACTIVE = "Chase::MarkedActiveActivity",
  PASS_AUDIT = "Chase::PassAuditActivity",
  PHONE_CALL = "Chase::PhoneCallActivity",
  QUALIFIED_CHASE = "Chase::QualifiedActivity",
  REMINDER = "Chase::ReminderActivity",
  START_CHASE = "Chase::CreateActivity",
}

export interface IChaseActivityAttributes {
  id: number;
  type: ChaseActivityType;
  createdAt: string;
  userId?: string;
  updatedAt?: string;
  message?: string;
  item?: {
    attributes: {
      description: string;
      createdAt: string;
      completedAt?: string;
      cancelledAt?: string;
      text?: string;
    }
  }
}

export interface IBaseChaseActivity {
  id: string;
}

export interface IChaseCloseActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.CLOSE;
    createdAt: string;
    userId?: string;
    message: string;
  }
}

export interface IChaseFailAuditActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.FAIL_AUDIT;
    createdAt: string;
    userId: string;
    message: string;
  }
}

export interface IChaseFlagActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.FLAG;
    createdAt: string;
    userId: string;
  }
}

export interface IChasePassAuditActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.PASS_AUDIT;
    createdAt: string;
    userId: string;
    message: string;
  }
}

export interface IChasePhoneCallActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.PHONE_CALL;
    item: IComment;
    createdAt: string;
    userId: string;
  }
}

export interface IChaseReminderActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.REMINDER;
    item: IReminder;
    createdAt: string;
    userId: string;
  }
}

export interface IChaseStartActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.START_CHASE;
    createdAt: string;
    updatedAt: string;
    userId: string;
  }
}

export interface IChaseMarkedActiveActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.MARKED_ACTIVE;
    createdAt: string;
    updatedAt: string;
    userId: string;
  }
}

export interface IChaseHotActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.HOT_CHASE;
    createdAt: string;
    updatedAt: string;
    userId: string;
  }
}

export interface IChaseQualifiedActivity extends IBaseChaseActivity {
  attributes: {
    type: ChaseActivityType.QUALIFIED_CHASE;
    createdAt: string;
    updatedAt: string;
    userId: string;
  }
}

export type IChaseActivity = IChaseCloseActivity |
IChaseFailAuditActivity |
IChaseFlagActivity |
IChasePassAuditActivity |
IChasePhoneCallActivity |
IChaseReminderActivity |
IChaseStartActivity |
IChaseMarkedActiveActivity |
IChaseHotActivity |
IChaseQualifiedActivity;
